import { Link } from "react-router-dom";

/** Soft paywall — shown inline when a free user hits a Pro-only feature. */
export default function ProPaywall({ feature, message }) {
  return (
    <div className="ff-card p-6 md:p-8 text-center" data-testid="pro-paywall">
      <div className="inline-flex items-center gap-2 bg-[#E8F0E9] text-[#3B5A3E] px-3 py-1 rounded-full text-xs font-medium uppercase tracking-wider">
        Pro feature
      </div>
      <h2 className="text-2xl md:text-3xl font-semibold mt-3" style={{ fontFamily: "Outfit, sans-serif" }}>
        {feature || "Unlock with Shop, Cal & Meal Pro"}
      </h2>
      <p className="text-sm text-[#5C6B61] mt-2 max-w-md mx-auto">
        {message || "Upgrade to Pro to use the weekly Planner, unlimited shopping lists, AI scans and more."}
      </p>
      <div className="flex gap-3 mt-5 justify-center flex-wrap">
        <Link to="/app/billing" className="ff-btn-primary text-sm" data-testid="upgrade-pro-btn">
          See pricing
        </Link>
        <Link to="/app/discover" className="ff-btn-ghost text-sm border border-[#E5E2DA]">
          Keep browsing
        </Link>
      </div>
    </div>
  );
}
